import { IMediaModel, channelTagsFromMedia } from "@nf/common";
import { CHANNELS, DEFAULT_COUNTRY_CODE } from "@nf/constants";
import { compareStrings } from "@nf/helpers";
import { useTranslation } from "next-i18next";

const getMediaChannelInfo = (media: IMediaModel) => {
  const channel = channelTagsFromMedia(media);

  const isKids = channel === CHANNELS.KIDS;
  const isDanskFilmskat = channel === CHANNELS.DANSK_FILMSKAT;
  const isDanish = !!media?.Countries?.find((country) =>
    compareStrings(country.Code, DEFAULT_COUNTRY_CODE)
  );

  return {
    isDanish,
    isDanskFilmskat,
    isKids,
  };
};

export const useMediaMetaTitle = (media: IMediaModel) => {
  const { t } = useTranslation("translations");
  const { isDanish, isDanskFilmskat, isKids } = getMediaChannelInfo(media);

  if (media.Seo?.Title) {
    return media.Seo.Title;
  }

  if (isKids) {
    return `Stream ${media.Title} | Sjovt og trygt børneunivers | Nordisk Film+`;
  }

  if (isDanskFilmskat) {
    return `Se ${media.Title} | Dansk Filmskat | Nordisk Film+`;
  }

  if (isDanish) {
    return `Se ${media.Title} | Danske film | Nordisk Film+`;
  }

  return t("web_meta_fallback_title", { title: media.Title });
};

export const useMediaMetaDescription = (media: IMediaModel) => {
  const { t } = useTranslation("translations");
  const { isDanish, isDanskFilmskat, isKids } = getMediaChannelInfo(media);

  if (media.Seo?.Description) {
    return media.Seo.Description;
  }

  if (isKids) {
    return t("web_meta_description_kids", { title: media.Title });
  }

  if (isDanskFilmskat) {
    return t("web_meta_description_dfs", { title: media.Title });
  }

  if (isDanish) {
    return t("web_meta_description_danish_movies", { title: media.Title });
  }

  return t("web_meta_description_rest", { title: media.Title });
};
